import React from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export default function EquityRaising() {
    const privateData = [
        "PE Funding",
        "VC Investments",
        "Angel Investments",
        "Family Offices",
    ];
    const publicData = [
        "IPO",
        "FPO",
        "Rights Issue",
        "OFS",
        "Pre-IPO",
        "Placement",
    ];
    const InstitutionalData = [
        "Institutional Placement",
        "Sovereign Funds",
        "Pension Funds",
        "Strategic Investors",
       
    ];
   
    return (
        <>
            <Header />
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-900  pt-36 pb-10 px-4 sm:px-6 lg:px-8">
                <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-[120px]" />
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 blur-[140px] rounded-full" />
                <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,.15)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.15)_1px,transparent_1px)] bg-[size:40px_40px]" />

                <div className="max-w-7xl mx-auto relative z-10">
                    {/* Breadcrumb */}
                    <div className="flex items-center  flex-wrap gap-2 text-sm text-white/70 mb-6">Home
                        <KeyboardArrowRightIcon className="w-4 h-4" />
                        <span className="text-cyan-300">
                            Expertise
                        </span>
                    </div>
                    <div className='max-w-6xl'>
                        <h1 className="text-3xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight mb-5">
                            Expertise:{" "}
                            <span className="text-dark-gold">
                                Equity Raising
                            </span>

                        </h1>

                        {/* Description */}
                        <p className=" text-white/70 text-lg sm:text-base lg:text-2xl leading-relaxed mb-8">
                            Strategic equity fundraising through private equity, venture capital, institutional investors, and strategic partnerships.
                            Helping businesses unlock long-term growth capital while enhancing valuation and investor confidence.
                        </p>





                    </div>
                </div>

                {/* section one */}
                <section className="py-20 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div>


                            </div>

                            {/* Right Points */}
                            <div className="space-y-5">
                                <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium">
                                    Private
                                </span>

                                <p className="text-2xl md:text-3xl text-white leading-tight mb-6">
                                    Private capital raising through strategic and financial investors.
                                </p>
                                <div className="grid grid-cols-3 gap-4 ">
                                    {privateData.map((point, index) => (
                                        <div
                                            key={index}
                                            className=" gap-4 bg-white/10 backdrop-blur-xl border border-white/10 rounded-xl py-5 px-4 hover:bg-white/15 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
                                        >


                                            <div>
                                                <h4 className="text-sm  text-white pt-3">
                                                    {point}
                                                </h4>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* end */}

                {/* section two */}
                <section className="py-10 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div>
                                <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium mb-5">
                                    Public
                                </span>
                                <p className="text-2xl md:text-3xl  text-white leading-tight mb-6">
                                    Capital market solutions for listed and pre-listed companies.
                                </p>
                               <div className="grid grid-cols-3 gap-4 ">
                                    {publicData.map((point, index) => (
                                        <div
                                            key={index}
                                            className=" gap-4 bg-white/10 backdrop-blur-xl border border-white/10 rounded-xl py-5 px-4 hover:bg-white/15 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
                                        >


                                            <div>
                                                <h4 className="text-sm  text-white pt-3">
                                                    {point}
                                                </h4>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Right Points */}
                            <div className="space-y-5"></div>

                        </div>
                    </div>
                </section>
                {/* end */}

                {/* three start */}
                <section className="py-10 px-4 sm:px-6 lg:px-8  ">
                    <div className="max-w-7xl mx-auto">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ">

                            {/* Left Content */}
                            <div className="">


                            </div>

                            {/* Right Points */}
                            <div className="space-y-5 " >
                                <div className="space-y-5 border-1">
                                    <span className="inline-block px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-400/20 text-cyan-400 text-sm font-medium ">
                                        Institutional
                                    </span>

                                    <p className="text-2xl md:text-3xl  text-white leading-tight mb-6">
                                        Fundraising from institutional and strategic investors for large-scale growth.
                                    </p>
                                    <div className="grid grid-cols-3 gap-4 ">
                                        {InstitutionalData.map((point, index) => (
                                            <div
                                                key={index}
                                                className=" gap-4 bg-white/10 backdrop-blur-xl border border-white/10 rounded-xl py-5 px-4 hover:bg-white/15 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
                                            >


                                                <div>
                                                    <h4 className="text-sm  text-white pt-3">
                                                        {point}
                                                    </h4>

                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* end */}

               

            </section>
            <Footer />
        </>
    )
}
